import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActions, Typography, Button, CardHeader } from '@material-ui/core';
import { genfunction } from 'helpers';
import ReactHtmlParser from 'react-html-parser';

const useStyles = makeStyles(theme => ({
    card: {
        "&:hover": {
            transform: 'scale(1.02)',
            WebkitTransform: 'scale(1.02)',
            boxShadow: "inset 0 0 0 2px",
            cursor: 'pointer'
        }
    },
    headerbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    }
}));

const DisplayCard = props => {

    const { Title, Description, ButtonText, ButtonCallBack, ButtonCallBackReference } = props;
    const classes = useStyles();
    return (
        <Card className={classes.card}>
            <CardHeader className={classes.headerbox}
                title={Title}
                titleTypographyProps={{ color: "inherit" }}
            />
            <CardContent>
                <Typography component="p" color="textSecondary">
                    <br />
                    {ReactHtmlParser(genfunction.replaceEscapeCharacters(Description))}
                </Typography>
            </CardContent>
            <CardActions>
                <Button variant="contained" onClick={() => ButtonCallBack(ButtonCallBackReference)} color="primary">{ButtonText}</Button>
            </CardActions>
        </Card>
    );
};

DisplayCard.propTypes = {
    Title: PropTypes.string.isRequired,
    Description: PropTypes.string.isRequired,
    ButtonText: PropTypes.string.isRequired,
    ButtonCallBack: PropTypes.func.isRequired,
    ButtonCallBackReference: PropTypes.object.isRequired
};

export default DisplayCard;
